// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyProfilePopup__scroll-container-cb03c4 {
  position: relative;
  overflow: auto;
}

.MyProfilePopup__close-f4b6be {
  position: absolute;
  top: 16px;
  inset-inline-end: 16px;
}

.MyProfilePopup__profile-meta-block-a6f561 {
  --meta-block-actions-background: var(--base-10);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MyProfilePopup/MyProfilePopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;AACF;;AAEA;EACE,+CAAA;AACF","sourcesContent":[".scroll-container {\n  position: relative;\n  overflow: auto;\n}\n\n.close {\n  position: absolute;\n  top: 16px;\n  inset-inline-end: 16px;\n}\n\n.profile-meta-block {\n  --meta-block-actions-background: var(--base-10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll-container": `MyProfilePopup__scroll-container-cb03c4`,
	"scrollContainer": `MyProfilePopup__scroll-container-cb03c4`,
	"close": `MyProfilePopup__close-f4b6be`,
	"profile-meta-block": `MyProfilePopup__profile-meta-block-a6f561`,
	"profileMetaBlock": `MyProfilePopup__profile-meta-block-a6f561`
};
module.exports = ___CSS_LOADER_EXPORT___;
